var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_14487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 7.71875H3.9375C3.57506 7.71875 3.28125 8.01256 3.28125 8.375V17.5625C3.28125 17.9249 3.57506 18.2188 3.9375 18.2188H17.0625C17.4249 18.2188 17.7188 17.9249 17.7188 17.5625V8.375C17.7188 8.01256 17.4249 7.71875 17.0625 7.71875Z",
    stroke: "#5E676E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.9531C11.0437 13.9531 11.4844 13.5124 11.4844 12.9688C11.4844 12.4251 11.0437 11.9844 10.5 11.9844C9.95634 11.9844 9.51562 12.4251 9.51562 12.9688C9.51562 13.5124 9.95634 13.9531 10.5 13.9531Z",
    fill: "#5E676E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21875 7.71875V5.09375C7.21875 4.22351 7.56445 3.38891 8.17981 2.77356C8.79516 2.1582 9.62976 1.8125 10.5 1.8125C11.3702 1.8125 12.2048 2.1582 12.8202 2.77356C13.4355 3.38891 13.7813 4.22351 13.7813 5.09375V7.71875",
    stroke: "#5E676E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_14487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.744aa3732f3566f9bc7a8b31368d858b.svg";
export { ForwardRef as ReactComponent };